import Component from '../Component';
import * as uiStrings from '../../uiStrings';

class Nav extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.setupEventListeners();
    }

    toggleActive() {
        this.refs['nav'].querySelectorAll('.js-nav-link').forEach((link) => {
            link.classList.toggle('active');
        });
    }

    setupEventListeners() {
        this.refs['nav'].addEventListener('click', (e) => {
            // do nothnig, if already active
            if (
                e.target.closest('.js-nav-item')
                    .querySelector('.js-nav-link')
                    .classList.contains('active')
            ) return;

            this.toggleActive();
            this.props.handleToggleContent();
        });
    }

    render() {
        return `
            <nav ref="nav" class="layerPanel__nav">
                <li class="layerPanel__nav__item js-nav-item">
                    <a class="layerPanel__nav__link js-nav-link active" href="#">${uiStrings.LOCATIONS_HEADING}</a>
                </li>
                <li class="layerPanel__nav__item js-nav-item">
                    <a class="layerPanel__nav__link js-nav-link" href="#">${uiStrings.DIVISION_HEADING}</a>
                </li>
            </nav>`;
    }
}

export default Nav;
